import React, { useState } from 'react';
import { colors } from '../theme';
import IProps from './interface';

const RewrittenWithAiIcon = ({
  color = colors.purpleHover,
  size = 24,
  bgColor = colors.purpleLight,
  hoverBgColor = colors.purpleLightHover,
}: Pick<IProps, 'size' | 'color'> & {
  bgColor?: string;
  hoverBgColor?: string;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const currentBgColor = isHovered ? hoverBgColor : bgColor;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ cursor: 'pointer' }}
    >
      <rect width="22" height="22" rx="11" fill={currentBgColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.74609 13.7962C7.0353 13.7962 8.0804 14.8413 8.0804 16.1305C8.0804 14.8413 9.1255 13.7962 10.4147 13.7962C9.1255 13.7962 8.0804 12.7511 8.0804 11.4619C8.0804 12.7511 7.0353 13.7962 5.74609 13.7962Z"
        stroke={color}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.582 12.0462C12.8712 12.0462 13.9163 13.0913 13.9163 14.3805C13.9163 13.0913 14.9614 12.0462 16.2506 12.0462C14.9614 12.0462 13.9163 11.0011 13.9163 9.71191C13.9163 11.0011 12.8712 12.0462 11.582 12.0462Z"
        stroke={color}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.08203 7.96077C9.37123 7.96077 10.4163 9.00587 10.4163 10.2951C10.4163 9.00587 11.4614 7.96077 12.7506 7.96077C11.4614 7.96077 10.4163 6.91567 10.4163 5.62646C10.4163 6.91567 9.37123 7.96077 8.08203 7.96077Z"
        stroke={color}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 18.5C24 21.5376 21.5376 24 18.5 24C15.4624 24 13 21.5376 13 18.5C13 15.4624 15.4624 13 18.5 13C21.5376 13 24 15.4624 24 18.5Z"
        fill="#0A9B94"
      />
      <path
        d="M16.5312 18.125L18.1063 19.625L20.4688 17.375"
        stroke="white"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RewrittenWithAiIcon;
